<template>
    <div class="page-container flex flex-direction">
        <header-modular :back="'返回首页'" :url="web_emof_member" :logo="o_info"></header-modular>
        <div class="content-container flex flex-direction flex-sub">
            <div class="content flex flex-direction">
                <div class="welcome flex align-center">
                    <div class="line flex-sub"></div>
                    <div class="flex-shrink margin-lr-sm">
                        欢迎<span class="margin-lr-xs">{{ users[0].name || users[0].morgname }}</span>进入会员管理系统，请选择角色
                    </div>
                    <div class="line flex-sub"></div>
                </div>
                <template v-if="users.filter(f=> { return f.type === 2 || (f.type === 4 && f.account_type === 1)}).length">
                    <div class="classify-title">管理端</div>
                    <swiper
                        class="classify-list"
                        :options="swiperOption"
                        :pagination="{ clickable: true }">
                        <swiper-slide class="item-user flex flex-direction padding-lr-xs"
                                      :class="[{lock:item.error_time || item.error_role || item.error_locking},
                                      {active:((user && item.mid === user.mid && item.type === 2) || (user && item.id === user.sid && item.type === 4))  && user.type === item.type}]"
                                      v-for="(item,index) in users.filter(f=> { return f.type === 2 || (f.type === 4 && f.account_type === 1)})" :key="index"
                                      @click.native="selectItem(item)">
                            <div class="flex align-center justify-between">
                                <div class="operate">
                                    <i class="icon iconfont icon-wode"></i>{{ item.type === 2 ? '管理员' : '子管理员' }}
                                </div>
                                <div class="operate blue" v-if="item.error_role"><i class="iconfont icon-quanxian"></i>无权限
                                </div>
                                <div class="operate blue" v-else-if="item.error_locking">
                                    <i class="iconfont icon-password"></i>已锁定
                                </div>
                                <div class="operate blue" v-else-if="item.error_time">
                                    <i class="iconfont icon-gengxinshijian"></i>已到期
                                </div>
                                <div class="operate blue" v-else >进入</div>
                            </div>
                            <div class="title">{{ item.morgname || item.org_name }}</div>
                        </swiper-slide>
                    </swiper>
                </template>
                <template v-if="users.filter(f=> { return f.type === 3 || (f.type === 4 && f.account_type === 2)}).length">
                    <div class="classify-title">分支机构端</div>
                    <swiper
                        class="classify-list"
                        :options="swiperOption"
                        :pagination="{ clickable: true }">
                        <swiper-slide class="item-user flex flex-direction padding-lr-xs"
                                      :class="[{lock:item.error_time || item.error_role || item.error_locking},,
                                      {active:((user && item.fhid === user.fhid && item.type === 3) || (user && item.id === user.sid && item.type === 4)) && user.type === item.type}]"
                                      v-for="(item,index) in users.filter(f=> { return f.type === 3 || (f.type === 4 && f.account_type === 2)})" :key="index"
                                      @click.native="selectItem(item)">
                            <div class="flex align-center justify-between" >
                                <div class="operate">
                                    <i class="icon iconfont icon-wode"></i>{{ item.type === 3 ? '管理员' : '子管理员' }}
                                </div>
                                <div class="operate blue" v-if="item.error_role"><i class="iconfont icon-quanxian"></i>无权限
                                </div>
                                <div class="operate blue" v-else-if="item.error_locking">
                                    <i class="iconfont icon-password"></i>已锁定
                                </div>
                                <div class="operate blue" v-else-if="item.error_time">
                                    <i class="iconfont icon-gengxinshijian"></i>已到期
                                </div>
                                <div class="operate blue" v-else>进入</div>
                            </div>
                            <div class="title">{{ item.morgname }}</div>
                        </swiper-slide>
                    </swiper>
                </template>
                <template v-if="users.filter(f=> { return f.type === 1}).length">
                    <div class="classify-title">会员端</div>
                    <swiper
                        class="classify-list"
                        :options="swiperOption"
                        :pagination="{ clickable: true }">
                        <swiper-slide class="item-user flex flex-direction padding-lr-xs"
                                      :class="[{lock:item.error_role || item.error_locking}
                                      ,{active:user && item.user_id === user.mid  && user.type === item.type}]"
                                      v-for="(item,index) in users.filter(f=> { return f.type === 1})" :key="index"
                                      @click.native="selectItem(item)">
                            <div class="flex align-center justify-between">
                                <div class="operate">
                                    <i class="icon iconfont icon-wode"></i>{{ item.user_type === 1 ? '单位会员' : '个人会员' }}
                                </div>
                                <div class="operate blue" v-if="item.error_role"><i class="iconfont icon-quanxian"></i>无权限
                                </div>
                                <div class="operate blue" v-else-if="item.error_locking">
                                    <i class="iconfont icon-password"></i>已锁定
                                </div>
                                <div class="operate blue" v-else-if="item.error_time">
                                    <i class="iconfont icon-gengxinshijian"></i>已到期
                                </div>
                                <div class="operate blue" v-else >进入</div>
                            </div>
                            <div class="title">{{ item.org_name }}</div>
                        </swiper-slide>
                    </swiper>
                </template>

            </div>
        </div>
        <footer-modular></footer-modular>
    </div>
</template>

<script>
import {agenLogin, agenSonLogin, getOrgLogo, updateUserLogin} from "@/api/login";
import FooterModular from "@/components/FooterModular.vue";
import HeaderModular from "@/components/HeaderModular.vue";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {addFenHuiIntegralRes} from "@/api/branch";
import {web_emof_member} from "@/utils/const";
import {TOAST, toast} from "@/utils/utils";

export default {
    name: "memberChoice",
    components: {FooterModular, HeaderModular, Swiper, SwiperSlide},
    data() {
        return {
            web_emof_member:web_emof_member,
            swiperOption: {
                slidesPerView: 3,
                loop: false,
                spaceBetween: 20,
                autoplay: false
            },
            o_info: ''
        }
    },
    created() {
        if (this.o_mid) {
            this.getOrgLogo()
        }else {
            let _item = this.users.find(f=>{ return !!f.morgwlogo})
            this.o_info ={
                morglogo: _item ? _item.morgwlogo : ''
            }
        }
        if (this.user) {
            this.init()
        }
        if (this.users.length === 0) this.$router.replace('/login')
        if (this.users.length === 1) this.selectItem(this.users[0])
    },
    computed: {
        o_mid() {
            return this.$store.state.o_mid
        },
        user() {
            return this.$store.state.user
        },
        users() {
            return this.$store.state.userAll
        }
    },
    methods: {
        async init() {
            let _data = await updateUserLogin(this.$store.state.user.account)
            this.$store.state.userAll = _data.data
            await window.localStorage.setItem('userAll', JSON.stringify(_data.data))
        },
        async getOrgLogo() {
            let _data = await getOrgLogo(this.o_mid)
            this.o_info = _data.data
        },
        async selectItem(item) {
            if(item.error_role || item.error_locking || (item.error_time && item.type !== 1)) return toast('账号状态已过期或已锁定',TOAST.error)
            switch (item.type) {
                case 1: {
                    let _data = await agenLogin(item.user_id)
                    if (_data.status === 200) {
                        this.$store.state.user = _data.data
                        this.$store.state.cookie_user = JSON.stringify(_data.data)
                        await window.localStorage.setItem('user', JSON.stringify(_data.data))
                        this.$router.replace('/member')
                    }
                }
                    break
                case 2: {
                    this.$store.state.user = item
                    this.$store.state.cookie_user = JSON.stringify(item)
                    await window.localStorage.setItem('user', JSON.stringify(item))
                    this.$router.replace('/organization')
                }
                    break
                case 4: {
                    let _data = await agenSonLogin(item.sign)
                    if (_data.status === 200) {
                        if (!_data.fenhui_id) {
                            this.$store.state.user = _data.data
                            this.$store.state.cookie_user = JSON.stringify(_data.data)
                            await window.localStorage.setItem('user', JSON.stringify(_data.data))
                            this.$router.replace('/organization')
                        } else {
                            _data.data.isBranch = true
                            this.$store.state.user = _data.data
                            this.$store.state.cookie_user = JSON.stringify(_data.data)
                            await window.localStorage.setItem('user', JSON.stringify(_data.data))
                            await addFenHuiIntegralRes(_data.data.fhid)
                            this.$router.replace('/branch')
                        }
                    }
                }
                    break
                case 3: {
                    item.isBranch = true
                    this.$store.state.user = item
                    this.$store.state.cookie_user = JSON.stringify(item)
                    await window.localStorage.setItem('user', JSON.stringify(item))
                    await addFenHuiIntegralRes(item.fhid)
                    this.$router.replace('/branch')
                }
                    break
            }
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.page-container {
    min-height: 100vh;

    .content-container {
        background-size: cover;
        background: url(../assets/img/bg_select_login.png) no-repeat center;

        .content {
            width: 1200px;
            margin: 80px auto 30px;

            .welcome {
                font-size: 26px;
                font-weight: 600;
                color: #0a2240;

                span {
                    color: #ff9600;
                }

                .line {
                    height: 1px;
                    background-color: #0a2240;
                }
            }

            .classify-title {
                font-size: 20px;
                font-weight: 600;
                color: #0a2240;
                margin-top: 40px;
                margin-bottom: 20px;


            }

            .classify-list {
                width: 100%;
                padding: 10px;

                .item-user {
                    width: 386px;
                    height: 120px;
                    border-radius: 20px;
                    background-color: #ffffff;
                    box-shadow: 0px 0px 8px 0px #ced8e5;
                    padding: 10px;
                    cursor: pointer;

                    &.active {
                        background-image: linear-gradient(90deg, #245592 0%, #0d3260 100%),
                        linear-gradient(#0a2240, #0a2240);
                        background-blend-mode: normal, normal;

                        .title {
                            color: #ffffff;
                        }

                        .operate {
                            &.blue {
                                color: #ff9600;
                            }
                        }
                    }

                    &.lock {
                        background: #ffffff;

                        .title {
                            color: #999999;

                            &:after {
                                background-color: #999999;
                            }
                        }

                        .operate {
                            background-color: #33333333;

                            &.blue {
                                cursor: no-drop;
                                color: #999999;
                            }
                        }
                    }

                    .operate {
                        min-width: 58px;
                        padding: 0 17px;
                        height: 30px;
                        line-height: 30px;
                        background-color: #296ec333;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #7599c4;

                        .icon {
                            height: 13px;
                            color: #ff9600;
                        }

                        &.blue {
                            color: #24456d;
                        }
                    }

                    .title {
                        font-size: 20px;
                        line-height: 1.5;
                        color: #24456d;
                        padding: 0 30px;
                        position: relative;
                        margin-top: 16px;

                        &:after {
                            position: absolute;
                            content: '';
                            width: 4px;
                            height: 22px;
                            background-color: #ff9600;
                            border-radius: 2px;
                            left: 10px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
            }
        }

    }
}
</style>
